import { useTranslation } from 'react-i18next';

// Returns all translations under a given prefix as an object
export function useTranslatedObject(prefix = '', variables = {}) {
  const { t } = useTranslation();
  return t(prefix, { returnObjects: true, ...variables }) || {};
}